const SS_VARIANT_SELECTOR = 'results-list[data-ss-variant-collection]';
const ssVariantInitialized = new WeakSet();

function ssVariantPrice(item) {
  const card = item.querySelector('product-card[data-ss-variant-price]');
  return Number(card?.dataset.ssVariantPrice || Number.MAX_SAFE_INTEGER);
}

function ssVariantTitle(item) {
  return item.querySelector('product-card')?.getAttribute('data-product-title') || item.textContent.trim();
}

async function ssLoadVariantCollection(resultsList) {
  if (ssVariantInitialized.has(resultsList)) return;
  ssVariantInitialized.add(resultsList);

  const meta = resultsList.querySelector('[data-ss-variant-sort-meta]');
  const totalPages = Number(meta?.dataset.pages || 1);
  const sectionId = resultsList.getAttribute('section-id');
  const grid = resultsList.querySelector('.product-grid');
  const status = resultsList.querySelector('[data-ss-variant-sort-status]');

  if (!grid || !sectionId) return;

  resultsList.dataset.ssVariantState = 'loading';

  try {
    const requests = [];
    for (let page = 2; page <= totalPages; page += 1) {
      const url = new URL(window.location.href);
      url.searchParams.set('page', String(page));
      url.searchParams.set('section_id', sectionId);
      requests.push(
        fetch(url, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
          .then((response) => {
            if (!response.ok) throw new Error(`Page ${page} returned ${response.status}`);
            return response.text();
          })
          .then((html) => ({ page, html }))
      );
    }

    const responses = await Promise.all(requests);
    responses.sort((a, b) => a.page - b.page);

    const knownIds = new Set(
      [...grid.querySelectorAll('.product-grid__item[data-product-id]')].map((item) => item.dataset.productId)
    );

    for (const { html } of responses) {
      const documentFragment = new DOMParser().parseFromString(html, 'text/html');
      const pageGrid = documentFragment.querySelector('.product-grid');
      if (!pageGrid) continue;

      for (const item of pageGrid.querySelectorAll('.product-grid__item[data-product-id]')) {
        if (knownIds.has(item.dataset.productId)) continue;
        knownIds.add(item.dataset.productId);
        grid.append(item);
      }
    }

    const descending = new URL(window.location.href).searchParams.get('sort_by') === 'price-descending';
    const items = [...grid.querySelectorAll('.product-grid__item')];
    items.sort((a, b) => {
      const priceDifference = ssVariantPrice(a) - ssVariantPrice(b);
      if (priceDifference !== 0) return descending ? -priceDifference : priceDifference;
      return ssVariantTitle(a).localeCompare(ssVariantTitle(b));
    });
    items.forEach((item) => grid.append(item));

    resultsList.querySelectorAll('pagination-component, .pagination, [data-pagination]').forEach((element) => element.remove());
    resultsList.dataset.ssVariantState = 'ready';
    if (status) status.textContent = `${items.length} sabers sorted by matching variant price`;
  } catch (error) {
    resultsList.dataset.ssVariantState = 'error';
    if (status) status.textContent = 'Products are shown with matching variant prices. Price sorting could not finish.';
    console.warn('[Saber Supply] Variant collection sorting failed', error);
  }
}

function ssInitializeVariantCollections(root = document) {
  if (root.matches?.(SS_VARIANT_SELECTOR)) ssLoadVariantCollection(root);
  root.querySelectorAll?.(SS_VARIANT_SELECTOR).forEach(ssLoadVariantCollection);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => ssInitializeVariantCollections());
} else {
  ssInitializeVariantCollections();
}

document.addEventListener('shopify:section:load', (event) => ssInitializeVariantCollections(event.target));

new MutationObserver((mutations) => {
  for (const mutation of mutations) {
    for (const node of mutation.addedNodes) {
      if (node.nodeType === Node.ELEMENT_NODE) ssInitializeVariantCollections(node);
    }
  }
}).observe(document.documentElement, { childList: true, subtree: true });
